(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
window.addEventListener('load', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // FORCE RTL LAYOUT ON HOMEPAGE - Mobile only
  document.addEventListener('DOMContentLoaded', function() {
    const isRTL = document.documentElement.getAttribute('dir') === 'rtl' || 
                  document.body.getAttribute('dir') === 'rtl';
    const isHomepage = document.body.classList.contains('template-index');
    const isMobile = window.innerWidth <= 749;
    
    if (isRTL && isHomepage && isMobile) {
      const header = document.querySelector('.header--flormar');
      if (header) {
        // Force grid layout
        header.style.setProperty('grid-template-columns', 'auto 1fr 90px 50px', 'important');
        header.style.setProperty('gap', '0 4rem', 'important');
        
        // Force logo position
        const logo = header.querySelector('.header__heading');
        if (logo) {
          logo.style.setProperty('grid-column', '3', 'important');
          logo.style.setProperty('padding-right', '4rem', 'important');
          logo.style.setProperty('margin', '0', 'important');
        }
        
        // Force hamburger position
        const hamburger = header.querySelector('header-drawer, .menu-drawer-container');
        if (hamburger) {
          hamburger.style.setProperty('grid-column', '4', 'important');
          hamburger.style.setProperty('justify-self', 'end', 'important');
          hamburger.style.setProperty('margin', '0', 'important');
        }
        
        // Force icons position
        const icons = header.querySelector('.header__icons');
        if (icons) {
          icons.style.setProperty('grid-column', '1', 'important');
          icons.style.setProperty('justify-self', 'start', 'important');
        }
      }
    }
  });

  // Smart Search Handler
  // Smart Search Handler
document.addEventListener('DOMContentLoaded', function() {
  const excludedTemplates = [
    'customers/login',
    'customers/register',
    'customers/reset_password',
    'customers/account',
    'customers/addresses',
    'customers/order'
  ];

  const excludedPaths = [
    '/account/login',
    '/account/register',
    '/account',
    '/account/addresses',
    '/account/reset'
  ];

  const template = document.body.getAttribute('data-template') || '';
  const currentPath = window.location.pathname;
  
  const shouldHideByTemplate = excludedTemplates.some(excluded => template.includes(excluded));
  const shouldHideByPath = excludedPaths.some(path => currentPath.includes(path));
  
  if (shouldHideByTemplate || shouldHideByPath) {
    document.body.classList.add('hide-smart-search');
  }

    const toggleBtn = document.getElementById('smart-search-toggle');
    const closeBtn = document.getElementById('smart-search-close');
    const headerElement = document.querySelector('.section-header');

    if (toggleBtn && headerElement) {
      toggleBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        headerElement.classList.add('search-expanded');
        
        const searchInput = document.getElementById('Search-In-Header');
        if (searchInput) {
          setTimeout(function() {
            searchInput.focus();
          }, 100);
        }
      });
    }

    if (closeBtn && headerElement) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        headerElement.classList.remove('search-expanded');
        
        const searchInput = document.getElementById('Search-In-Header');
        if (searchInput) {
          searchInput.value = '';
          searchInput.blur();
        }
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && headerElement && headerElement.classList.contains('search-expanded')) {
        headerElement.classList.remove('search-expanded');
        const searchInput = document.getElementById('Search-In-Header');
        if (searchInput) {
          searchInput.blur();
        }
      }
    });

    // Close search when clicking outside
    document.addEventListener('click', function(e) {
      if (!headerElement) return;
      
      const searchContainer = headerElement.querySelector('.header__search');
      const searchToggle = document.getElementById('smart-search-toggle');
      
      if (headerElement.classList.contains('search-expanded')) {
        if (searchContainer && !searchContainer.contains(e.target) && 
            searchToggle && !searchToggle.contains(e.target)) {
          headerElement.classList.remove('search-expanded');
          const searchInput = document.getElementById('Search-In-Header');
          if (searchInput) {
            searchInput.blur();
          }
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
